/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import Auth from "../../modules/Auth";
import { Link, useNavigate } from "react-router-dom";
import config from "../../modules/config";
import { Typography, Box, Card } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import { getUser, setUser } from "../../state/actions";
import { connect } from "react-redux";
import { RootState } from "../../state/reducers/index.js";
import { InputFormEvent } from "../../common/model/InputFormEvent.js";
import { InputChangeEvent } from "../../common/model/InputChangeEvent.js";
import { AuthProps } from "../../types/AuthProps";
import { COMPETES_URL } from "../../components/navbar/Navbar";
import Layout from "../../components/layout/Layout";
import "./signup.style.scss";
import { SignUpForm } from "../../components/signupform/SignUpForm";
import axios from "axios";
import { Capacitor } from "@capacitor/core";
const platform = Capacitor.getPlatform();

const SignUpPage = (props: AuthProps) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (Auth.isUserAuthenticated()) {
      navigate("/competes");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState<any>({
    email: "",
    name: "",
    password: "",
    repeatPassword: "",
  });

  const processForm = (event: InputFormEvent) => {
    event.preventDefault();

    // Check if passwords match
    if (user.password !== user.repeatPassword) {
      setErrors({ ...errors, repeatPassword: "Passwords do not match." });
      return; // Stop the form submission
    }

    let UnAthorizedHeader = config.UnAthorizedHeader();
    axios
      .post(
        `${process.env.REACT_APP_CROQEE_SERVER_URL}/auth/signup`,
        user,
        UnAthorizedHeader
      )
      .then((response) => {
        setErrors({});
        localStorage.setItem("successMessage", response.data.message);
        navigate("/login");
      })
      .catch((error) => {
        if (error?.response?.data) {
          const { errors } = error.response.data;
          setErrors(errors);
        }
      });
  };

  const changeUser = (event: InputChangeEvent) => {
    const field = event.target.name;
    const _user = { ...user };
    _user[field] = event.target.value;
    setUser(_user);
  };

  const responseGoogle = (response: any) => {
    axios
      .post(`${process.env.REACT_APP_CROQEE_SERVER_URL}/auth/googleauth`, {
        googleCredentialToken: response.credential,
      })
      .then((res) => {
        const { token, user } = res.data;
        props.setUser(user);
        setErrors({});
        Auth.authenticateUser(token);
        props.getUser();
        navigate(COMPETES_URL);
      })
      .catch((err) => console.error(err));
  };

  return (
    <Layout>
      <Box className={"signup"}>
        <Card className="signup__card">
          <SignUpForm
            onSubmit={processForm}
            onChange={changeUser}
            errors={errors}
            user={user as any}
          />
         {
         platform === "web" &&
         <GoogleLogin
            onSuccess={responseGoogle}
            onError={() => responseGoogle}
            text={"continue_with"}
            size={"large"}
            width="100%"
          />}
        </Card>
        <div
          style={{
            textAlign: "center",
            margin: "auto",
            width: "100%",
            marginTop: "1em",
          }}
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Already registered? <Link to={"/login"}>Login</Link>.
          </Typography>
        </div>
      </Box>
    </Layout>
  );
};


const mapStateToProps = (state: RootState) => {};
const mapDispatchToProps = (dispatch: any) => {
  return {
    getUser: () => dispatch(getUser()),
    setUser: (user: any) => dispatch(setUser(user)),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
